import React, { useState, Fragment, useEffect, useRef } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { Close, NavigateBefore, Save } from '@mui/icons-material';
import { nuevoOActualizarRegistroPersonalizado, patchPersonalizadoConDosMetodos, setearDatosAlStore, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { useDispatch } from 'react-redux';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import { useHistory } from 'react-router-dom';
import Formulario from 'components/formulario';
import TelevisionYRadio from './TelevisionYRadio';
import { TablaPersonalizada } from 'components';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import Escritos from './Escritos';
import Exterior from './Exterior';
import { tipoDeClasificaionRadio, tiposDeMediosEscritos, tiposDeMediosExterior, tiposMediosPorID } from 'constantes/globalsStates';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { functions } from 'constantes/functions';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import IndicadorDeCarga from 'components/IndicadorDeCarga';

let dataToValidate = [];
let datosDeArrendatarioGlobal = { esArrendatario: false, fechaInicioArrendamiento: "", fechaFinArrendamiento: "", proPolitica: "", pdfContratoArrenda: "" }
let medioSeleccionadoGlobal = 0;

const CaracteristicaDelMedio = ({ activeStep, numberStep, datosDeEmpresa, listadoPersonaIndividual, personaIndividual, personaLegal, listadoDeCaracteristicasDelMedio, arrendatario, handleClose, obtenerRegistros, idSolicitud }) => {

    const dispatch = useDispatch();
    let history = useHistory();
    const listadoDeCaracteristicasRef = useRef([]);
    const [dataItem, setDataItem] = useState({}),
        [listadoDeCaracteristicas, setListadoDeCaracteristicas] = useState([]),
        [showModalDeleteOrganization, setShowModalDeleteOrganization] = useState(false),
        [medioSeleccinado, setMedioSeleccionado] = useState(0),
        [header] = useState([
            { title: 'Empresa', field: 'empresa', cellStyle: { maxWidth: '80px' } },
            { title: 'Medio de comunicación', field: 'tipoDeMedio.name', cellStyle: { maxWidth: '80px' } },
            { title: 'Tipo o clasificación de medio', field: 'tipoOClasificacionDelMedio.name', cellStyle: { maxWidth: '80px' } },
            {
                title: 'Acción', field: 'accion',
                render: rowData => <div style={{ maxWidth: '80px' }}>
                    {
                        (<div>
                            <TooltipPersonalizado title="Eliminar el medio de comunicación del listado" handleFunction={() => removerElemento(rowData)} icon="delete"></TooltipPersonalizado>
                        </div>)
                    }
                </div>
            },
        ]);
    const [mostrarMedio, setMostrarMedio] = useState(false)
    const [datosDeArrendatario, setDatosDeArrendatario] = useState({ ...datosDeArrendatarioGlobal })
    datosDeArrendatarioGlobal = datosDeArrendatario;
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, })
    const [cargandoSolicitud, setcargandoSolicitud] = useState(false);

    useEffect(() => {
        const cargarListadoInicial = async () => {
            if (idSolicitud) {
                await recargarListadoDeCaracteristicas();
                return;
            }

            if (listadoDeCaracteristicasDelMedio?.length > 0) {
                validarListadoEsMayor(false)
                setListadoDeCaracteristicas(listadoDeCaracteristicasDelMedio)
                listadoDeCaracteristicasRef.current = listadoDeCaracteristicasDelMedio
            }
        }

        cargarListadoInicial();
    }, []);

    useEffect(() => {
        listadoDeCaracteristicasRef.current = listadoDeCaracteristicas;
        dataToValidate = listadoDeCaracteristicas;
    }, [listadoDeCaracteristicas])

    const normalizarFecha = (fecha) => {
        if (!fecha) return null;

        if (fecha instanceof Date && !Number.isNaN(fecha.getTime())) {
            return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        }

        if (typeof fecha === 'string') {
            const valor = fecha.trim();
            
            // Formato DD/MM/YYYY o DD-MM-YYYY
            const matchDMY = valor.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
            if (matchDMY) {
                const day = Number(matchDMY[1]);
                const month = Number(matchDMY[2]) - 1;
                const year = Number(matchDMY[3]);
                const parsed = new Date(year, month, day);

                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
                return null;
            }

            // Formato ISO: YYYY-MM-DD o YYYY/MM/DD
            const matchISO = valor.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/);
            if (matchISO) {
                const year = Number(matchISO[1]);
                const month = Number(matchISO[2]) - 1;
                const day = Number(matchISO[3]);
                const parsed = new Date(year, month, day);

                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
                return null;
            }

            // Intenta parsear como construcción general (más leniente para otros formatos)
            const parsed = new Date(valor);
            if (!Number.isNaN(parsed.getTime())) {
                return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
            }
        }

        return null;
    }

    const formatearFechaParaBackend = (fecha) => {
        const date = normalizarFecha(fecha);
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const normalizarFechasRequestMedio = (item = {}) => ({
        ...item,
        fechaVigenciaHastaUncosu: item?.fechaVigenciaHastaUncosu ? formatearFechaParaBackend(item.fechaVigenciaHastaUncosu) : '',
        fechaVigenciaHastaSit: item?.fechaVigenciaHastaSit ? formatearFechaParaBackend(item.fechaVigenciaHastaSit) : '',
        fechaVigenciaHastaSatelital: item?.fechaVigenciaHastaSatelital ? formatearFechaParaBackend(item.fechaVigenciaHastaSatelital) : '',
        fechaInicioArrendamiento: item?.fechaInicioArrendamiento ? formatearFechaParaBackend(item.fechaInicioArrendamiento) : '',
        fechaFinArrendamiento: item?.fechaFinArrendamiento ? formatearFechaParaBackend(item.fechaFinArrendamiento) : '',
    })

    const construirListadoDesdeSolicitud = (solicitud = {}) => {
        const {
            nombreEmpresa,
            solicitudTV = [],
            solicitudRadio = [],
            solicitudEscrito = [],
            solicitudExteriores = []
        } = solicitud;

        const listado = [];

        solicitudTV.forEach((item) => {
            const {
                numeroCertificacionUncosu,
                fechaVigenciaHastaUncosu,
                numeroCertificacionSit,
                fechaVigenciaHastaSit,
                licOpSatelital,
                numeroOrdenSatel,
                numeroRegistroSatel,
                fechaVigenciaSatelital,
                tipoDeTelevision,
                idTipoDeTelevision,
                id
            } = item;

            listado.push({
                empresa: nombreEmpresa,
                tipoDeMedio: tiposMediosPorID[1],
                tipoOClasificacionDelMedio: {
                    id: tipoDeTelevision?.id || idTipoDeTelevision || '',
                    name: tipoDeTelevision?.descripcion || tipoDeTelevision?.name || ''
                },
                solicitudEmpresaTelevisionRequest: {
                    idTipoDeTelevision: idTipoDeTelevision || 0,
                    numeroCertificacionUncosu: Number(idTipoDeTelevision) === 1 ? numeroCertificacionUncosu || '' : '',
                    fechaVigenciaHastaUncosu: Number(idTipoDeTelevision) === 1 ? normalizarFecha(fechaVigenciaHastaUncosu) || '' : '',
                    pdfConstanciaUncosu: '',
                    numeroCertificacionSit: Number(idTipoDeTelevision) === 2 ? numeroCertificacionSit || '' : '',
                    fechaVigenciaHastaSit: Number(idTipoDeTelevision) === 2 ? normalizarFecha(fechaVigenciaHastaSit) || '' : '',
                    pdfConstanciaSit: '',
                    licenciaDeOperacionDeFacilidades: licOpSatelital,
                    numeroDeOrdenSatelital: Number(idTipoDeTelevision) === 3 ? numeroOrdenSatel || '' : '',
                    numeroDeRegistroSatelital: Number(idTipoDeTelevision) === 3 ? numeroRegistroSatel || '' : '',
                    fechaVigenciaHastaSatelital: Number(idTipoDeTelevision) === 3 ? normalizarFecha(fechaVigenciaSatelital) || '' : '',
                    pdfConstanciaLicenciaSatelital: '',
                },
                id,
            });
        });

        solicitudRadio.forEach((item) => {
            const { numeroCertificacionSit, fechaVigenciaSit, radioAM, radioFM, id } = item;

            let tipoDeRadioSolicitud = 0;

            if (radioAM && radioFM) tipoDeRadioSolicitud = 10;
            else if (radioAM && !radioFM) tipoDeRadioSolicitud = 4;
            else tipoDeRadioSolicitud = 5;

            listado.push({
                empresa: nombreEmpresa,
                tipoDeMedio: tiposMediosPorID[2],
                tipoOClasificacionDelMedio: tipoDeClasificaionRadio[tipoDeRadioSolicitud],
                solicitudEmpresaRadioRequest: {
                    radioAM,
                    radioFM,
                    numeroDeCertificacionSit: numeroCertificacionSit || '',
                    fechaVigenciaHastaSit: normalizarFecha(fechaVigenciaSit) || '',
                    pdfConstanciaSit: '',
                },
                id,
            });
        });

        solicitudEscrito.forEach((item) => {
            const { tipoDeCirculacionDeMedioEscrito, tipoDeMedioEscrito, enlaceWeb, id } = item;

            listado.push({
                empresa: nombreEmpresa,
                tipoDeMedio: tiposMediosPorID[3],
                tipoOClasificacionDelMedio: {
                    id: tipoDeMedioEscrito?.id || '',
                    name: tipoDeMedioEscrito?.descripcion || tipoDeMedioEscrito?.name || ''
                },
                id,
                solicitudEmpresaEscritosRequest: {
                    tipoDeMedioEscrito: tipoDeMedioEscrito?.id || '',
                    idTipoCirculacionDeMedio: Number(tipoDeCirculacionDeMedioEscrito?.id) || '',
                    tieneSitioWeb: enlaceWeb !== '' ? false : true,
                    sitioWeb: enlaceWeb || '',
                },
            });
        });

        solicitudExteriores.forEach((item) => {
            const { esvalla, espantalla, autorizacionMunicipal, tipoExterior, idTipoExterior, id } = item;
            const tipoExteriorNormalizado = Number(tipoExterior || idTipoExterior || (espantalla ? 4 : esvalla ? 5 : 0));

            listado.push({
                empresa: nombreEmpresa,
                tipoDeMedio: tiposMediosPorID[4],
                tipoOClasificacionDelMedio: tiposDeMediosExterior[tipoExteriorNormalizado] || tiposDeMediosExterior[5],
                solicitudEmpresaExteriorRequest: {
                    esPantalla: tipoExteriorNormalizado === 4,
                    esValla: [4, 5, 6].includes(tipoExteriorNormalizado),
                    tieneAutorizacionMunicipal: autorizacionMunicipal,
                    tipoExterior: tipoExteriorNormalizado || 5
                },
                id,
            });
        });

        return listado;
    }

    const recargarListadoDeCaracteristicas = async () => {
        if (!idSolicitud) return [];

        const respuesta = await dispatch(obtenerRegistrosPorURL({
            controller: 'formularioDeRegistroDeMediosDeComunicacion',
            saveInStore: false,
            nombreDelMetodo: 'listar/registros',
            parametro: idSolicitud
        }));

        const nuevoListado = construirListadoDesdeSolicitud(respuesta?.data || {});
        setListadoDeCaracteristicas(nuevoListado);
        listadoDeCaracteristicasRef.current = nuevoListado;
        validarListadoEsMayor(nuevoListado.length === 0);
        return nuevoListado;
    }

    const obtenerClaveFila = (item = {}) => {
        const tipo = Number(item?.tipoDeMedio?.id || 0);
        const tv = item?.solicitudEmpresaTelevisionRequest || {};
        const radio = item?.solicitudEmpresaRadioRequest || {};
        const escrito = item?.solicitudEmpresaEscritosRequest || {};
        const exterior = item?.solicitudEmpresaExteriorRequest || {};
        const clasificacion = item?.tipoOClasificacionDelMedio;

        if (tipo === 1) {
            const clasificacionId = Number(tv?.idTipoDeTelevision || clasificacion?.id || clasificacion || 0);
            return `${tipo}-${clasificacionId}`;
        }

        if (tipo === 2) {
            if (radio?.radioAM && radio?.radioFM) return `${tipo}-10`;
            if (radio?.radioAM && !radio?.radioFM) return `${tipo}-4`;
            if (!radio?.radioAM && radio?.radioFM) return `${tipo}-5`;

            const radioTexto = typeof clasificacion === 'string' ? clasificacion : '';
            const radioIdPorTexto = Object.keys(tipoDeClasificaionRadio).find((key) => tipoDeClasificaionRadio[key] === radioTexto);
            return `${tipo}-${Number(radioIdPorTexto || clasificacion?.id || clasificacion || 0)}`;
        }

        if (tipo === 3) {
            const clasificacionId = Number(escrito?.tipoDeMedioEscrito || clasificacion?.id || clasificacion || 0);
            return `${tipo}-${clasificacionId}`;
        }

        if (tipo === 4) {
            const clasificacionId = Number(
                exterior?.tipoExterior ||
                (exterior?.esPantalla ? 4 : exterior?.esValla ? 5 : 0) ||
                clasificacion?.id ||
                clasificacion ||
                0
            );
            return `${tipo}-${clasificacionId}`;
        }

        return `${tipo}-0`;
    }

    const construirClavePorTipoYClasificacion = (tipoMedioId, clasificacionId) => `${Number(tipoMedioId || 0)}-${Number(clasificacionId || 0)}`;

    const existeMedioEnListado = (tipoMedioId, clasificacionId, listado = listadoDeCaracteristicas) => {
        const claveBuscada = construirClavePorTipoYClasificacion(tipoMedioId, clasificacionId);
        return (listado || []).some((item) => obtenerClaveFila(item) === claveBuscada);
    }

    const obtenerClasificacionRadioDeItem = (item = {}) => {
        if (Number(item?.tipoDeMedio?.id) !== 2) return null;

        const radio = item?.solicitudEmpresaRadioRequest || {};
        if (radio?.radioAM && radio?.radioFM) return 10;
        if (radio?.radioAM && !radio?.radioFM) return 4;
        if (!radio?.radioAM && radio?.radioFM) return 5;

        const clasificacion = item?.tipoOClasificacionDelMedio;

        if (typeof clasificacion === 'number') return clasificacion;
        if (typeof clasificacion === 'string') {
            const id = Number(Object.keys(tipoDeClasificaionRadio).find((key) => tipoDeClasificaionRadio[key] === clasificacion));
            return Number.isNaN(id) ? null : id;
        }

        const id = Number(clasificacion?.id);
        return Number.isNaN(id) ? null : id;
    }

    const existeConflictoDeClasificacionRadio = (clasificacionSeleccionada, listado = listadoDeCaracteristicas) => {
        const clasificacion = Number(clasificacionSeleccionada);
        if (![4, 5, 10].includes(clasificacion)) return false;

        const clasificacionesActuales = (listado || [])
            .filter((item) => Number(item?.tipoDeMedio?.id) === 2)
            .map(obtenerClasificacionRadioDeItem)
            .filter((item) => item !== null);

        if (clasificacion === 10) {
            return clasificacionesActuales.some((item) => item === 4 || item === 5 || item === 10);
        }

        return clasificacionesActuales.some((item) => item === 10);
    }

    const removerElementoDelListadoLocal = (rowItem) => {
        const claveFila = obtenerClaveFila(rowItem);

        setListadoDeCaracteristicas((prevState) => {
            const newData = prevState.filter((item) => {
                if (rowItem?.id && item?.id) return item.id !== rowItem.id;
                return obtenerClaveFila(item) !== claveFila;
            });

            listadoDeCaracteristicasRef.current = newData;

            if (newData.length === 0) validarListadoEsMayor(true);
            return newData;
        });
    }

    const existeVigenciaVencida = () => {
        const hoyDate = new Date();
        const hoy = new Date(hoyDate.getFullYear(), hoyDate.getMonth(), hoyDate.getDate());

        return dataToValidate.some((item) => {
            const tipo = Number(item?.tipoDeMedio?.id || 0);

            if (tipo === 1) {
                const tv = item?.solicitudEmpresaTelevisionRequest || {};
                const fechaTv =
                    tv?.fechaVigenciaHastaUncosu ||
                    tv?.fechaVigenciaHastaSit ||
                    tv?.fechaVigenciaHastaSatelital ||
                    null;

                const fecha = normalizarFecha(fechaTv);
                return !!fecha && fecha < hoy;
            }

            if (tipo === 2) {
                const radio = item?.solicitudEmpresaRadioRequest || {};
                const fecha = normalizarFecha(radio?.fechaVigenciaHastaSit);
                return !!fecha && fecha < hoy;
            }

            return false;
        });
    }

    const obtenerMensajeErrorFechasListado = () => {
        const hoyDate = new Date();
        const hoy = new Date(hoyDate.getFullYear(), hoyDate.getMonth(), hoyDate.getDate());

        for (const item of dataToValidate) {
            const tipo = Number(item?.tipoDeMedio?.id || 0);

            if (tipo === 1) {
                const tv = item?.solicitudEmpresaTelevisionRequest || {};
                const tipoTv = Number(tv?.idTipoDeTelevision || 0);

                let fechaVigencia = null;
                if (tipoTv === 1) fechaVigencia = tv?.fechaVigenciaHastaUncosu;
                if (tipoTv === 2) fechaVigencia = tv?.fechaVigenciaHastaSit;
                if (tipoTv === 3 && tv?.licenciaDeOperacionDeFacilidades) fechaVigencia = tv?.fechaVigenciaHastaSatelital;

                if (fechaVigencia !== null && fechaVigencia !== undefined && fechaVigencia !== '') {
                    const fecha = normalizarFecha(fechaVigencia);
                    // Solo validar si la fecha se normalizó correctamente
                    if (fecha && fecha < hoy) return 'Certificación y Registro vencido';
                } else if (tipoTv === 1 || tipoTv === 2 || (tipoTv === 3 && tv?.licenciaDeOperacionDeFacilidades)) {
                    return 'Debe ingresar fecha de vigencia';
                }

                if (tv?.esArrendatario) {
                    if (!tv?.fechaFinArrendamiento) return 'Debe ingresar fecha final de arrendamiento.';

                    const fechaFinal = normalizarFecha(tv?.fechaFinArrendamiento);

                    if (fechaFinal && fechaFinal < hoy) {
                        return 'Contrato de arrendamiento vencido.';
                    }
                }
            }

            if (tipo === 2) {
                const radio = item?.solicitudEmpresaRadioRequest || {};

                if (!radio?.fechaVigenciaHastaSit) return 'Debe ingresar fecha de vigencia';

                const fecha = normalizarFecha(radio?.fechaVigenciaHastaSit);
                // Solo validar si la fecha se normalizó correctamente
                if (fecha && fecha < hoy) return 'Certificación y Registro vencido';

                if (radio?.esArrendatario) {
                    if (!radio?.fechaFinArrendamiento) return 'Debe ingresar fecha final de arrendamiento.';

                    const fechaFinal = normalizarFecha(radio?.fechaFinArrendamiento);

                    if (fechaFinal && fechaFinal < hoy) {
                        return 'Contrato de arrendamiento vencido.';
                    }
                }
            }
        }

        return '';
    }

    const obtenerValorSeleccionado =async ({target}) => {
        if(!target.value) {
            setMostrarMedio(false)
            medioSeleccionadoGlobal = 0;
            setMedioSeleccionado(0)
            return;
        };

        /*if(dataToValidate?.length > 0 ) {
            const existElement = dataToValidate.some((item) => Number(item.tipoDeMedio?.id) === Number(target.value))

            if(existElement) {
                setMostrarMedio(false)
                return setResponseData({ errorType: 'warning', messageType: `EL MEDIO YA FUE AGREGADA AL LISTADO!.`, openResponse: true, });
            }
        }*/
        setMostrarMedio(true)
        setMedioSeleccionado(Number(target?.value))
        medioSeleccionadoGlobal = Number(target?.value);
    };

    const agregarAlListado = async (dataForm) => {
        // Validar duplicados con el estado local vigente del listado.
        // Recargar desde backend justo antes de validar puede reintroducir elementos recién eliminados.
        let listadoActualParaValidaciones = listadoDeCaracteristicasRef.current;

        //if (dataToValidate?.length === 4) return setResponseData({ errorType: 'warning', messageType: `SOLO PUEDE AGREGAR 4 MEDIOS DE COMUNICACIÓN AL LISTADO!.`, openResponse: true, });

        /*if(dataToValidate?.length > 0 ) {
            const existElement = dataToValidate.some((item) => Number(item.tipoDeMedio?.id) === Number(medioSeleccionadoGlobal))
            if(existElement) {
                setMostrarMedio(false)
                return setResponseData({ errorType: 'warning', messageType: `EL MEDIO YA FUE AGREGADA AL LISTADO!.`, openResponse: true, });
            }
        }*/

        let tipoOClasificacionDelMedio = "";
        let solicitudEmpresaTelevisionRequest = {};
        let solicitudEmpresaRadioRequest = {}
        let solicitudEmpresaEscritosRequest = {}
        let solicitudEmpresaExteriorRequest = {}

        switch (medioSeleccionadoGlobal) {
            case 1: // TELEVISION
                const { tipoTv, facilidadSatelital, numeroCertificacion, numeroOrden, numeroRegistro, fechaVigencia, constanciaUncosu, esArrendatario, fechaInicio, FechaFinal, autorizacionProPolitica, contratoArrendatario } = dataForm;

                solicitudEmpresaTelevisionRequest = {
                    // TV POR CABLE
                    "idTipoDeTelevision": tipoTv?.id || 0,

                    "numeroCertificacionUncosu": Number(tipoTv?.id) === 1 ? numeroCertificacion || "" : "",
                    //"numeroOrdenUncosu": Number(tipoTv?.id) === 1 ? numeroOrden || "" : "",
                    //"numeroRegistroUncosu": Number(tipoTv?.id) === 1 ? numeroRegistro || "" : "",
                    "fechaVigenciaHastaUncosu": Number(tipoTv?.id) === 1 ? fechaVigencia || "" : "",
                    "pdfConstanciaUncosu": Number(tipoTv?.id) === 1 ? constanciaUncosu || "" : "",

                    // TV ABIERTA
                    "numeroCertificacionSit": Number(tipoTv?.id) === 2 ? numeroCertificacion || "" : "",
                    //"numeroOrdenSit": Number(tipoTv?.id) === 2 ? numeroOrden || "" : "",
                    //"numeroRegistroSit": Number(tipoTv?.id) === 2 ? numeroRegistro || "" : "",
                    "fechaVigenciaHastaSit": Number(tipoTv?.id) === 2 ? fechaVigencia || "" : "",
                    "pdfConstanciaSit": Number(tipoTv?.id) === 2 ? constanciaUncosu || "" : "",

                    // TV SATELITAL
                    "licenciaDeOperacionDeFacilidades": facilidadSatelital === '1' ? true : false,
                    "numeroDeOrdenSatelital": Number(tipoTv?.id) === 3 ? numeroOrden || "" : "",
                    "numeroDeRegistroSatelital": Number(tipoTv?.id) === 3 ? numeroRegistro || "" : "",
                    "fechaVigenciaHastaSatelital": Number(tipoTv?.id) === 3 ? fechaVigencia || "" : "",
                    "pdfConstanciaLicenciaSatelital": Number(tipoTv?.id) === 3 ? constanciaUncosu || "" : "",

                    // DATOS DEL ARRENDATARIO
                    esArrendatario: esArrendatario === '1' ? true : false,
                    fechaInicioArrendamiento: fechaInicio || "",
                    fechaFinArrendamiento: FechaFinal || "",
                    proPolitica: autorizacionProPolitica === '1' ? true : false,
                    pdfContratoArrenda: contratoArrendatario || ""
                }
                solicitudEmpresaTelevisionRequest = normalizarFechasRequestMedio(solicitudEmpresaTelevisionRequest)

                tipoOClasificacionDelMedio = tipoTv;

                const existElementTv = existeMedioEnListado(medioSeleccionadoGlobal, tipoTv?.id, listadoActualParaValidaciones);

                if (existElementTv) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'YA AGREGÓ ESTE TIPO DE TELEVISIÓN',
                        openResponse: true
                    });
                }

                // setDatosDeArrendatario({
                //     esArrendatario : esArrendatario === '1' ? true : false,
                //     fechaInicioArrendamiento :fechaInicio || "",
                //     fechaFinArrendamiento :FechaFinal || "",
                //     proPolitica : autorizacionProPolitica === '1' ? true : false,
                //     pdfContratoArrenda : contratoArrendatario || ""
                // })

                if (!idSolicitud) {
                    setListadoDeCaracteristicas(prevState => {
                        const nextState = [...prevState, {
                            empresa: datosDeEmpresa?.nombreEmpresa,
                            tipoDeMedio: tiposMediosPorID[medioSeleccionadoGlobal],
                            tipoOClasificacionDelMedio,
                            solicitudEmpresaTelevisionRequest,
                        }];
                        listadoDeCaracteristicasRef.current = nextState;
                        return nextState;
                    })
                }
                break;
            case 2: // RADIO
                const clasificacionRadioSeleccionada = Number(dataForm?.tipoClasificacion);

                if (existeConflictoDeClasificacionRadio(clasificacionRadioSeleccionada, listadoActualParaValidaciones)) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: clasificacionRadioSeleccionada === 10
                            ? 'NO PUEDE AGREGAR "RADIO AM Y FM" SI YA EXISTE RADIO AM O RADIO FM EN EL LISTADO'
                            : 'NO PUEDE AGREGAR RADIO AM O RADIO FM SI YA EXISTE "RADIO AM Y FM" EN EL LISTADO',
                        openResponse: true
                    });
                }

                let radioAM = false;
                let radioFM = false;

                switch (clasificacionRadioSeleccionada) {
                    case 4:
                        radioAM = true
                        radioFM = false
                        break;
                    case 5:
                        radioAM = false
                        radioFM = true
                        break;
                    case 10:
                        radioAM = true
                        radioFM = true
                        break;
                    default:
                        radioAM = false
                        radioFM = false
                        break;
                }

                solicitudEmpresaRadioRequest = {
                    radioAM,
                    radioFM,
                    "numeroCertificacionSit": dataForm?.numeroCertificacion || "",
                    //"numeroDeOrdenSit": dataForm?.numeroOrden || "",
                    //"numeroDeRegistroSit": dataForm?.numeroRegistro || "",
                    "fechaVigenciaHastaSit": dataForm?.fechaVigencia || "",
                    "pdfConstanciaSit": dataForm?.constanciaUncosu || "",
                    esArrendatario: dataForm?.esArrendatario === '1' ? true : false,
                    fechaInicioArrendamiento: dataForm?.fechaInicio || "",
                    fechaFinArrendamiento: dataForm?.FechaFinal || "",
                    proPolitica: dataForm?.autorizacionProPolitica === '1' ? true : false,
                    pdfContratoArrenda: dataForm?.contratoArrendatario || ""
                }
                solicitudEmpresaRadioRequest = normalizarFechasRequestMedio(solicitudEmpresaRadioRequest)

                tipoOClasificacionDelMedio = tipoDeClasificaionRadio[clasificacionRadioSeleccionada];

                const existElementRadio = existeMedioEnListado(medioSeleccionadoGlobal, clasificacionRadioSeleccionada, listadoActualParaValidaciones);

                if (existElementRadio) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'YA AGREGÓ ESTE TIPO DE RADIO',
                        openResponse: true
                    });
                }

                // setDatosDeArrendatario({
                //     esArrendatario: dataForm?.esArrendatario === '1' ? true : false,
                //     fechaInicioArrendamiento: dataForm?.fechaInicio || "",
                //     fechaFinArrendamiento: dataForm?.FechaFinal || "",
                //     proPolitica: dataForm?.autorizacionProPolitica === '1' ? true : false,
                //     pdfContratoArrenda: dataForm?.contratoArrendatario || ""
                // })

                if (!idSolicitud) {
                    setListadoDeCaracteristicas(prevState => {
                        const nextState = [...prevState, {
                            empresa: datosDeEmpresa?.nombreEmpresa,
                            tipoDeMedio: tiposMediosPorID[medioSeleccionadoGlobal],
                            tipoOClasificacionDelMedio,
                            solicitudEmpresaRadioRequest,
                        }];
                        listadoDeCaracteristicasRef.current = nextState;
                        return nextState;
                    })
                }
                break;
            case 3: // ESCRITOS
                const { tipoMedioEscrito, tipoEdicionEscrito, esWeb, linkWeb } = dataForm;

                solicitudEmpresaEscritosRequest = {
                    "tipoDeMedioEscrito": tipoMedioEscrito?.id || "",
                    "idTipoCirculacionDeMedio": Number(tipoEdicionEscrito) || "",
                    "tieneSitioWeb": esWeb === '1' ? false : true,
                    "sitioWeb": linkWeb || "",
                }

                tipoOClasificacionDelMedio = tiposDeMediosEscritos[Number(tipoMedioEscrito?.id)];
                const existElementEscritos = existeMedioEnListado(medioSeleccionadoGlobal, Number(tipoMedioEscrito?.id), listadoActualParaValidaciones);

                if (existElementEscritos) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'YA AGREGÓ ESTE TIPO DE MEDIO ESCRITO',
                        openResponse: true
                    });
                }
                if (!idSolicitud) {
                    setListadoDeCaracteristicas(prevState => {
                        const nextState = [...prevState, {
                            empresa: datosDeEmpresa?.nombreEmpresa,
                            tipoDeMedio: tiposMediosPorID[medioSeleccionadoGlobal],
                            tipoOClasificacionDelMedio,
                            solicitudEmpresaEscritosRequest,
                        }];
                        listadoDeCaracteristicasRef.current = nextState;
                        return nextState;
                    })
                }
                break;
            case 4: // MEDIOS ALTERNATIVOS
                const { tipoMedioAlternativo, tipoValla, autorizacionMunicipal, enlacesPaginasWeb = [] } = dataForm;
                const tipoAlternativoSeleccionado = Number(tipoMedioAlternativo?.id || 0);
                const tipoExteriorSeleccionado = tipoAlternativoSeleccionado === 1 ? Number(tipoValla?.id || 0) : tipoAlternativoSeleccionado === 2 ? 7 : 0;
                const listadoEnlacesPaginasWeb = Array.isArray(enlacesPaginasWeb)
                    ? enlacesPaginasWeb.filter((item) => !!item)
                    : [];

                if (!tipoExteriorSeleccionado || !tiposDeMediosExterior[tipoExteriorSeleccionado]) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'DEBE SELECCIONAR EL TIPO DE MEDIO ALTERNATIVO',
                        openResponse: true
                    });
                }

                if (tipoExteriorSeleccionado === 7 && listadoEnlacesPaginasWeb.length === 0) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'DEBE INGRESAR AL MENOS UN LINK DE PÁGINA WEB',
                        openResponse: true
                    });
                }

                solicitudEmpresaExteriorRequest = {
                    esPantalla: tipoExteriorSeleccionado === 4 ? true : false,
                    esValla: [4, 5, 6].includes(tipoExteriorSeleccionado),
                    tieneAutorizacionMunicipal: tipoExteriorSeleccionado === 7 ? false : Number(autorizacionMunicipal) === 1 ? true : false,
                    enlacesPaginasWeb: tipoExteriorSeleccionado === 7 ? listadoEnlacesPaginasWeb : [],
                    sitioWeb: tipoExteriorSeleccionado === 7 ? listadoEnlacesPaginasWeb.join(' | ') : '',
                    tipoExterior: tipoExteriorSeleccionado,
                }

                tipoOClasificacionDelMedio = tiposDeMediosExterior[tipoExteriorSeleccionado];

                const existElementExterior = existeMedioEnListado(medioSeleccionadoGlobal, tipoExteriorSeleccionado, listadoActualParaValidaciones);

                if (existElementExterior) {
                    return setResponseData({
                        errorType: 'warning',
                        messageType: 'YA AGREGÓ ESTE TIPO DE MEDIO ALTERNATIVO',
                        openResponse: true
                    });
                }

                if (!idSolicitud) {
                    setListadoDeCaracteristicas(prevState => {
                        const nextState = [...prevState, {
                            empresa: datosDeEmpresa?.nombreEmpresa,
                            tipoDeMedio: tiposMediosPorID[medioSeleccionadoGlobal],
                            tipoOClasificacionDelMedio,
                            solicitudEmpresaExteriorRequest,
                        }];
                        listadoDeCaracteristicasRef.current = nextState;
                        return nextState;
                    })
                }
                break;
            default:
                return <Typography>No existen Componente para mostrar</Typography>;
        }

        // SI ESTA EDITANDO LA SOLICITUD SE AGREGARA EL MEDIO A BASE DE DATOS Y SE MOSTRARA DE MANERA LOCAL
        if (idSolicitud) {
            setcargandoSolicitud(true);

            const datosAEnviar = {
                solicitudEmpresaTelevisionRequest: [solicitudEmpresaTelevisionRequest],
                solicitudEmpresaRadioRequest: [solicitudEmpresaRadioRequest],
                solicitudEmpresaEscritosRequest: [solicitudEmpresaEscritosRequest],
                solicitudEmpresaExteriorRequest: [solicitudEmpresaExteriorRequest],
                idSolicitudDeEmpresa: idSolicitud
            };

            const objetoAEnviar = { controller: "formularioDeRegistroDeMediosDeComunicacion", action: "crear", data: datosAEnviar, nombreDelMetodo: "crear/registrosDeMediosNuevosASolicitud" };
            const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(objetoAEnviar));
            setcargandoSolicitud(false);

            if (respuesta?.error) {
                await recargarListadoDeCaracteristicas();
                return setResponseData({ errorType: 'error', messageType: respuesta?.error?.message || respuesta?.message || "No se puedo guardar los datos, intente nuevamente!", openResponse: true, });
            }

            await recargarListadoDeCaracteristicas();
            setResponseData({ errorType: 'success', messageType: respuesta?.data?.data || "MEDIO REGISTRADO CORRECTAMENTE!", openResponse: true, });
        }

        listadoDeBotones.saveData.disabled = false;
        const elementosReiniciados = functions.reiniciarEstadoDelFormulario({ ...elementosDelFormulario });
        setCamposDelFormulario({ ...elementosReiniciados });
        setMostrarMedio(false);
        setMedioSeleccionado(0);
        medioSeleccionadoGlobal = 0;
    };

    const renderizarComponente = () => {

        switch (medioSeleccinado) {
            case 1: // TELEVISION
                return <TelevisionYRadio tipodeMedio={{ id: 1, name: 'TELEVISIÓN' }} agregarAlListado={agregarAlListado} />
            case 2: // RADIO
                return <TelevisionYRadio tipodeMedio={{ id: 2, name: 'RADIO' }} agregarAlListado={agregarAlListado} />
            case 3: // ESCRITOS
                return <Escritos tipodeMedio={{ id: 3, name: 'ESCRITOS' }} agregarAlListado={agregarAlListado} />
            case 4: // MEDIOS ALTERNATIVOS
                return <Exterior tipodeMedio={{id: 4, name: 'MEDIOS ALTERNATIVOS'}} agregarAlListado={agregarAlListado} />
            default:
                return <Typography>No existen Componente para mostrar</Typography>;
        }
    }

    const [elementosDelFormulario, setCamposDelFormulario] = useState({
        tituloTipoMedio: {
            idelement: "tituloTipoMedio", title: 'Tipo de medio', position: "center", value: "", isError: false, showTitleForm: true, name: "tituloTipoMedio",
        },
        tipodeMedio: {
            idelement: "tipodeMedio", value: null, label: "Seleccione el tipo de medio *", pattern: "^[1-9][1-9]*$", validators: ['required'],
            errorMessages: ['Seleccione el tipo de medio'], isError: false, elementType: 'autoCompletar', list: [{ id: 1, name: "TELEVISIÓN" }, { id: 2, name: "RADIO" }, { id: 3, name: "ESCRITOS" }, {id: 4, name: "MEDIOS ALTERNATIVOS"}], handler: obtenerValorSeleccionado, autoFocus: true, disabled: false, width: '80%'
        },
    });

    const validarListadoEsMayor = (disabled) => {
        const newButtonList = Object.assign({}, listadoDeBotones);
        newButtonList.saveData.disabled = disabled
        setButtonList(newButtonList)
    }

    const manejadorActionModal = async () => {
        const { tipoDeMedio, id } = dataItem;
        const claveFila = obtenerClaveFila(dataItem);

        if (!idSolicitud) {
            setShowModalDeleteOrganization(false);
            removerElementoDelListadoLocal(dataItem);
            return setResponseData({ errorType: 'success', messageType: 'MEDIO ELIMINADO CORRECTAMENTE!', openResponse: true, });
        }

        let idMedioAEliminar = id || 0;

        if (!idMedioAEliminar) {
            const listadoActual = await recargarListadoDeCaracteristicas();
            const filaActual = listadoActual.find((item) => obtenerClaveFila(item) === claveFila);
            idMedioAEliminar = filaActual?.id || 0;
        }

        if (!idMedioAEliminar) {
            setShowModalDeleteOrganization(false);
            removerElementoDelListadoLocal(dataItem);
            return setResponseData({ errorType: 'warning', messageType: 'No se encontró identificador del medio en base de datos. Se eliminó solo del listado local.', openResponse: true, });
        }

        setcargandoSolicitud(true);

        const datosAEnviar = {
            "idMedioDeComunicacion": idMedioAEliminar,
            "idTipoMedioDeComunicacion": tipoDeMedio?.id
        }

        const data = { controller: "formularioDeRegistroDeMediosDeComunicacion", action: 'eliminar', data: datosAEnviar, method: "registrosDeMedioDeComunicacion", methodTwo: "", tipoMetodo: "DELETE" };

        const respuesta = await dispatch(patchPersonalizadoConDosMetodos(data));
        setShowModalDeleteOrganization(false);

        if (respuesta?.error) {
            setcargandoSolicitud(false);
            return setResponseData({ errorType: 'error', messageType: respuesta?.error?.message || respuesta?.message || "No se puedo eliminar los datos, intente nuevamente!", openResponse: true, });
        }

        const listadoActualizado = await recargarListadoDeCaracteristicas();
        const medioSigueVisible = listadoActualizado.some((item) => obtenerClaveFila(item) === claveFila);

        if (medioSigueVisible) {
            setcargandoSolicitud(false);
            return setResponseData({ errorType: 'warning', messageType: 'El servidor respondió correctamente, pero el medio sigue apareciendo. Recargue e intente nuevamente.', openResponse: true, });
        }

        // Reset selection/form state to avoid stale values after deleting an item
        setMostrarMedio(false);
        setMedioSeleccionado(0);
        medioSeleccionadoGlobal = 0;

        setResponseData({ errorType: 'success', messageType: respuesta?.data?.data || "MEDIO ELIMINADO CORRECTAMENTE!", openResponse: true, });
        setcargandoSolicitud(false);
    }

    const removerElemento = (rowItem) => {
        setDataItem(rowItem)
        setShowModalDeleteOrganization(true);
    }

    const closeModalDeleteOrganization = () => {
        setShowModalDeleteOrganization(false);
    }

    const saveData = async () => {

        if (dataToValidate?.length === 0) {
            setMostrarMedio(false)
            return setResponseData({ errorType: 'warning', messageType: `DEBE AGREGAR AL MENOS UN MEDIO DE COMUNICACIÓN AL LISTADO!.`, openResponse: true, });
        }

        const mensajeErrorFechas = obtenerMensajeErrorFechasListado();
        if (mensajeErrorFechas) {
            return setResponseData({
                errorType: 'warning',
                messageType: mensajeErrorFechas,
                openResponse: true,
            });
        }

        setcargandoSolicitud(true);
        const datosAEnviar = {
            // INICIO DATOS DE LA EMPRESA
            "nombreEmpresa": datosDeEmpresa?.nombreEmpresa || "",
            "direccion": datosDeEmpresa?.direccionEmpresa || "",
            "notificacion": datosDeEmpresa?.direccionNotificaciones || "",
            "correoElectronico": datosDeEmpresa?.correoElectronico || "",
            "telefono": datosDeEmpresa?.telefono || "",
            "telefono1": datosDeEmpresa?.telefono2 || "",

            "nombreEnlaceMedio": datosDeEmpresa?.nombreEnlace || "",
            "correoEnlaceMedio": datosDeEmpresa?.correoElectronicoMedio || "",
            "telEnlaceMedio": datosDeEmpresa?.telefonoMedio || "",

            "patente": datosDeEmpresa?.patente || "",
            "patenteRegistro": datosDeEmpresa?.registro || "",
            "patenteFolio": datosDeEmpresa?.folio || "",
            "patenteLibro": datosDeEmpresa?.libro || "",
            "numeroRegistroTimbre": datosDeEmpresa?.NumeroRegistro || "",
            "fechaInscripcionTimbre": datosDeEmpresa?.FechaInscripcion ? formatearFechaParaBackend(datosDeEmpresa?.FechaInscripcion) : "",
            "fechaVigenciaHastaTimbre": datosDeEmpresa?.FechaVigencia ? formatearFechaParaBackend(datosDeEmpresa?.FechaVigencia) : "",
            "pdfPatenteComer": datosDeEmpresa?.archivoPatenteComercio || "",
            "pdfDeclaracion": datosDeEmpresa?.declaracionJurada || "",
            "pdfConstInscr": datosDeEmpresa?.archivoTimbre || "",
            "pdfSolvenciaTimbre": datosDeEmpresa?.solvenciaTimbre || "",
            "esPersonaIndividual": datosDeEmpresa?.tipoPropietario === '1' ? true : false,
            "tipoDeEmpresaId": datosDeEmpresa?.tipoPropietario ? Number(datosDeEmpresa.tipoPropietario) : "",
            // FIN

            // POSIBLES REPETIDOS
            "docDeclaracion": datosDeEmpresa?.declaracionJurada || "",
            "docPatente": datosDeEmpresa?.archivoPatenteComercio || "",
            "logo": "",
            "correoContacto": datosDeEmpresa?.correoElectronico || "",
            "telefonoContato": datosDeEmpresa?.telefono || "",
            // FIN

            // INICIO DATOS DEL PROPIETARIO (PERSONA QUE EMITE FACTURA)
            "nitSolicitante": personaIndividual?.nit || "",
            "nombreSolicitante": personaIndividual?.nombreEmiteFactura || "",
            "pdfConstanciaRTU": personaIndividual?.constanciaRTU || "",

            "nroExpedienteRGAE": personaIndividual?.noRegistro || "",
            "nroResolucionRGAE": personaIndividual?.numeroResolucion || "",
            "nroreFolionRGAE": personaIndividual?.folioRGAE || "",
            "pdfConstanciaRGAE": personaIndividual?.constanciaRGAE || "",
            // FIN

            // INICIO Datos contrato arrendatario solo si es MEDIO TELEVISION Y RADIO
            "esArrendatario": datosDeArrendatarioGlobal?.esArrendatario,
            "fechaInicioArrendamiento": datosDeArrendatarioGlobal?.fechaInicioArrendamiento || "",
            "fechaFinArrendamiento": datosDeArrendatarioGlobal?.fechaFinArrendamiento || "",
            "proPolitica": datosDeArrendatarioGlobal?.proPolitica || false,
            "pdfContratoArrenda": datosDeArrendatarioGlobal?.pdfContratoArrenda || "",
            // FIN

            "idTipoMedio": 0,
            solicitudEmpresaTelevisionRequest: {},
            solicitudEmpresaRadioRequest: {},
            solicitudEmpresaEscritosRequest: {},
            solicitudEmpresaExteriorRequest: {}
        }

        datosAEnviar.personaIndividual = listadoPersonaIndividual || [];

        const personaJuridicaOLegal = {
            "razonSocial": personaLegal?.razonSocial || null,
            "nombreComercial": personaLegal?.nombreComercial || null,

            "nroEscrituraConst": personaLegal?.numeroConstitucion || null,
            "nroConstitucion": personaLegal?.numeroConstitucion || null,
            "fechaEscriturConst": (listadoPersonaIndividual?.length === 0) ? (formatearFechaParaBackend(personaLegal?.fechaEscritura) || null) : null,
            "notarioConstitucion": personaLegal?.nombreNotario || null,
            "nroInscripcionEscriConst": personaLegal?.numeroInscripcion || null,
            "folioConstitucion": personaLegal?.folio || null,
            "libroConstitucion": personaLegal?.libro || null,
            "pdfConstituSociedad": personaLegal?.constitucionSociedad || null,

            "cuiRepresentante": personaLegal?.cuiRepresentanteLegal || null,
            "nombreCompletoRepresentante": personaLegal?.nombreRepresentante || null,
            "vigenciaHasta": (listadoPersonaIndividual?.length === 0) ? (formatearFechaParaBackend(personaLegal?.fechaVigencia) || null) : null,
            "folioRepresentante": personaLegal?.folioRepresentante || null,
            "libroRepresentate": personaLegal?.libroRepresentante || null,
            "registroRepresentante": personaLegal?.registroRepresentante || null,
            "pdfConstanciaRepresentante": personaLegal?.certificacionRegistroMercantil || null
        }

        datosAEnviar.personaJuridica = personaJuridicaOLegal;

        if (idSolicitud) {
            datosAEnviar.solicitudEmpresaTelevisionRequest = {};
            datosAEnviar.solicitudEmpresaRadioRequest = {}
            datosAEnviar.solicitudEmpresaEscritosRequest = {}
            datosAEnviar.solicitudEmpresaExteriorRequest = {}
        } else {
            dataToValidate.forEach(item => {
                switch (Number(item?.tipoDeMedio?.id)) {
                    case 1: // TELEVISION
                        datosAEnviar.solicitudEmpresaTelevisionRequest = normalizarFechasRequestMedio(item.solicitudEmpresaTelevisionRequest)
                        break;
                    case 2: // RADIO
                        datosAEnviar.solicitudEmpresaRadioRequest = normalizarFechasRequestMedio(item.solicitudEmpresaRadioRequest)
                        break;
                    case 3: // ESCRITOS
                        datosAEnviar.solicitudEmpresaEscritosRequest = item.solicitudEmpresaEscritosRequest
                        break;
                    case 4: // EXTERIOR
                        datosAEnviar.solicitudEmpresaExteriorRequest = item.solicitudEmpresaExteriorRequest
                        break;
                    default:
                        break;
                }
            })
        }

        let objetoAEnviar = {}
        let respuesta = {};

        if (idSolicitud) {
            datosAEnviar.idSolicitud = idSolicitud;
            objetoAEnviar = { controller: "formularioDeRegistroDeMediosDeComunicacion", action: "editar", data: datosAEnviar, nombreDelMetodo: "" };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(objetoAEnviar));
        } else {
            const solicitudEmpresaTelevisionRequest = [];
            const solicitudEmpresaRadioRequest = [];
            const solicitudEmpresaEscritosRequest = [];
            const solicitudEmpresaExteriorRequest = [];

            dataToValidate.forEach(item => {
                switch (Number(item?.tipoDeMedio?.id)) {
                    case 1:
                        solicitudEmpresaTelevisionRequest.push(normalizarFechasRequestMedio(item.solicitudEmpresaTelevisionRequest || {}));
                        break;
                    case 2:
                        solicitudEmpresaRadioRequest.push(normalizarFechasRequestMedio(item.solicitudEmpresaRadioRequest || {}));
                        break;
                    case 3:
                        solicitudEmpresaEscritosRequest.push(item.solicitudEmpresaEscritosRequest || {});
                        break;
                    case 4:
                        solicitudEmpresaExteriorRequest.push(item.solicitudEmpresaExteriorRequest || {});
                        break;
                    default:
                        break;
                }
            });

            const payloadCrearV2 = {
                solicitudEmpresaRequest: {
                    ...datosAEnviar,
                    solicitudEmpresaTelevisionRequest: {},
                    solicitudEmpresaRadioRequest: {},
                    solicitudEmpresaEscritosRequest: {},
                    solicitudEmpresaExteriorRequest: {}
                },
                solicitudEmpresaTelevisionRequest,
                solicitudEmpresaRadioRequest,
                solicitudEmpresaEscritosRequest,
                solicitudEmpresaExteriorRequest
            };

            objetoAEnviar = {
                controller: "formularioDeRegistroDeMediosDeComunicacion",
                action: "crear",
                data: payloadCrearV2,
                nombreDelMetodo: "crear/v2"
            };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(objetoAEnviar));

            const idSolicitudCreada = respuesta?.data?.idSolicitud || respuesta?.data?.data?.idSolicitud;
            if (idSolicitudCreada) {
                await dispatch(obtenerRegistrosPorURL({
                    controller: "formularioDeRegistroDeMediosDeComunicacion",
                    saveInStore: false,
                    nombreDelMetodo: "listar/registros",
                    parametro: idSolicitudCreada
                }));
            }
        }

        setcargandoSolicitud(false);

        if (respuesta?.error) return setResponseData({ errorType: 'error', messageType: respuesta?.error?.message || respuesta?.message || "No se puedo guardar los datos, intente nuevamente!", openResponse: true, });

        dispatch(setearDatosAlStore({ dispatchAction: nombreDeAcciones.CLEAN_ALL_REDUCER }));
        handleClose(true);
        alertaPersonalizadaSwal(respuesta?.data?.data || "SU SOLICITUD DIGITAL, SE REGISTRÓ CORRECTAMENTE!", "", "success");
        obtenerRegistros()
    }

    const backAction = async () => {

        dispatch(setearDatosAlStore({
            dispatchAction: nombreDeAcciones.SET_DATA_CARACTERISTICAS_MEDIOS,
            data: {
                listadoDeCaracteristicasDelMedio: dataToValidate,
            }
        }));

        dispatch(setearDatosAlStore({
            dispatchAction: nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP,
            data: {
                activeStep: activeStep - 1,
                numberStep: numberStep - 1
            }
        }));
    };

    const cancelAction = () => {
        dispatch(setearDatosAlStore({ dispatchAction: nombreDeAcciones.CLEAN_ALL_REDUCER }));
        history.replace("/registroDeTelevision");
    };

    const [listadoDeBotones, setButtonList] = React.useState({
        "backAction": {
            "label": "Regresar", "icon": <NavigateBefore />, "callback": backAction, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border": "0px", "borderRadius": "3",
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: true,
        },
        "saveData": {
            "label": "Guardar datos", "icon": <Save />, "callback": saveData, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border": "0px", "borderRadius": "3",
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: true,
        },
        "cancelAction": {
            "label": "Cancelar", "icon": <Close />, "callback": cancelAction, "loading": false, "size": "medium",
            "background": "linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border": "0px", "borderRadius": "3",
            "boxShadow": "0 3px 5px 2px rgba(33, 203, 243, .3)", "color": "white", "height": 37, padding: "0 30px", disabled: false, isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') { return }
        changeDataResponse('warning', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setResponseData({ errorType, messageType, openResponse, })
    };

    const { errorType, messageType, openResponse } = responseData;

    return (
        <Fragment>
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose} />
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : ''}
            <Card>
                <CardContent>
                    <Formulario
                        elements={elementosDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                </CardContent>
                <Grid container justifyContent={"space-between"} alignItems={"flex-start"} >
                    <Grid item xs={12} md={6}>
                        {mostrarMedio && (
                            <CardContent> {renderizarComponente()} </CardContent>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TablaPersonalizada
                            showPagination={true}
                            data={listadoDeCaracteristicas}
                            title={"Listado de medios de comunicación"}
                            header={header}
                            detailPanel={[]}
                        />
                    </Grid>
                </Grid>
                {showModalDeleteOrganization && (
                    <ModalDeConfirmacion
                        title={`¿Está seguro de eliminar el medio?`} message={"No podrá revertir esta acción"}
                        open={showModalDeleteOrganization} closeModal={closeModalDeleteOrganization} titleButton={"Sí, estoy seguro"}
                        actionAdd={manejadorActionModal}
                    />
                )}

            </Card>
        </Fragment>
    );
}

export default CaracteristicaDelMedio;